import { type AppMode } from '@databases/modes';

import { createEmbedModeConfig } from '../modes/embed/embed-mode-config';
import { createMobileModeConfig } from '../modes/mobile/mobile-mode-config';
import { createNativeEmbedModeConfig } from '../modes/native-embed/native-embed-mode-config';
import { createNativeEmbedEditorPluginModeConfig } from '../modes/native-embed-editor-plugin/native-embed-editor-plugin-mode-config';
import { type ModeConfig } from '../modes/types';
import { createDefaultModeConfig } from '../modes/utils/create-default-mode-config';

export { type ModeConfig } from '../modes/types';

export function getModeConfig(mode: AppMode): ModeConfig {
  const modeConfigs: Record<typeof mode, () => ModeConfig> = {
    EMBED: createEmbedModeConfig,
    MOBILE: createMobileModeConfig,
    NATIVE_EMBED: createNativeEmbedModeConfig,
    NATIVE_EMBED_EDITOR_PLUGIN: createNativeEmbedEditorPluginModeConfig,
    STANDALONE: createDefaultModeConfig,
  };

  const config = modeConfigs[mode];

  return config();
}
